import { Component, Input } from '@angular/core';
import { UXBanner, UXBlock, UXPage } from '../../../core/models/ux-page';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-page-decoration',
  templateUrl: './page-decoration.component.html',
  styleUrls: ['./page-decoration.component.scss']
})
export class PageDecorationComponent {
  @Input() page: UXPage
  @Input() type: 'default' | 'home' = 'default'

  fullWidthView$: Observable<boolean>

  constructor(private store: Store<any>) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  get hasBanner(): boolean {
    return !!this.page.banner && !!this.page.banner.img
  }

  get banner(): UXBanner {
    return this.page.banner
  }

  get hasBlocks(): boolean {
    return !!this.page.blocks.length
  }

  get hasPageText(): boolean {
    return !!this.page.introText
  }

  get blocks(): UXBlock[] {
    return this.page.blocks
  }

  get hasText(): boolean {
    return !!this.page.introText
  }

  get text(): string {
    return this.page.introText
  }

  get name(): string {
    return this.page.name
  }

}
